import React from "react";
import styled from "styled-components";

const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Item = styled.div`
  background-color: ${(props) =>
    props.active ? props.theme.palette.primary : "white"};
  color: ${(props) => (props.active ? "white" : props.theme.palette.primary)};
  font-family: ${(props) => props.theme.typo.fontFamily};
  font-size: ${(props) => (props.variant === "small" ? "12px" : "14px")};
  font-weight: 600;
  width: ${(props) => (props.variant === "small" ? "24px" : "36px")};
  height: ${(props) => (props.variant === "small" ? "24px" : "36px")};
  line-height: 1;
  margin-right: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.14);
  flex-shrink: 0;
  cursor: pointer;
`;

const Pagination = ({ count, currentIndex, onClick, variant }) => {
  return (
    <Items>
      {Array.from(Array(count)).map((_, index) => (
        <Item
          key={index}
          variant={variant}
          onClick={() => onClick(index)}
          active={index === currentIndex}
        >
          {index + 1}
        </Item>
      ))}
    </Items>
  );
};

Pagination.defaultProps = {
  count: 1,
  currentIndex: 0,
  onClick: () => console.log("click"),
  variant: ""
};

export default Pagination;
